// extracted by mini-css-extract-plugin
export default {"buttonContainer":"_6z971","alignToEdge":"isqXZ","buttonIcon":"ot-Js","buttonCaption":"BMCsx","buttonSpacer":"uTpc4"};